/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendInteractions.defs.js'
export { main as default } from './sendInteractions.defs.js'
